import { Injectable } from "@angular/core";
import { environment, AuthMode } from "../../environments/environment";
import { AdalService } from "./adal.service";
import { AwsAuthServiceService } from "./aws-auth-service.service";
import { Observable } from "rxjs";
import { HttpParams } from "@angular/common/http";

const CurrentAuthMode = environment.currentAuthMode;

@Injectable({
  providedIn: "root"
})
export class AzureAwsSwitchService {
  constructor(private azure: AdalService, public aws: AwsAuthServiceService) {}

  public get currentAuthMode(): string {
    return CurrentAuthMode;
  }

  public setContext() {
    if (CurrentAuthMode === AuthMode.Azure) {
      this.azure.context.handleWindowCallback();
    } else if (CurrentAuthMode === AuthMode.AWS) {
      this.aws.setAuthInstance();
    }
  }

  public login() {
    if (CurrentAuthMode === AuthMode.Azure) {
      this.azure.context.login();
    } else if (CurrentAuthMode === AuthMode.AWS) {
      this.aws.login();
    }
  }

  public logout() {
    if (CurrentAuthMode === AuthMode.Azure) {
      this.azure.logout();
    } else if (CurrentAuthMode === AuthMode.AWS) {
      this.aws.logout();
    }
  }

  public get isLogged() {
    if (CurrentAuthMode === AuthMode.Azure) {
      return this.azure.isLogged;
    } else if (CurrentAuthMode === AuthMode.AWS) {
      console.log(this.aws.isSessionExists);
      return this.aws.isSessionExists;
    }
  }

  public get(url: string, params?: HttpParams): Observable<any> {
    if (CurrentAuthMode === AuthMode.Azure) {
      return this.azure.get(url, params);
    } else if (CurrentAuthMode === AuthMode.AWS) {
      return this.aws.get(url, params);
    }
  }

  public post(url: string, data: any): Observable<any> {
    if (CurrentAuthMode === AuthMode.Azure) {
      return this.azure.post(url, data);
    } else if (CurrentAuthMode === AuthMode.AWS) {
      return this.aws.post(url, data);
    }
  }

  public getAttachment(url: string, params?: HttpParams): Observable<any> {
    if (CurrentAuthMode === AuthMode.Azure) {
      return this.azure.getAttachment(url, params);
    } else if (CurrentAuthMode === AuthMode.AWS) {
      return this.aws.getAttachment(url, params);
    } 
  }

  public getLoggedInUserProfilePhoto(): Observable<any> {
    if (this.currentAuthMode === AuthMode.Azure) {
      return this.azure.getLoggedInUserProfilePhoto();
    } else if (this.currentAuthMode === AuthMode.AWS) {
      return this.aws.getLoggedInUserProfilePhoto();
    }
  }

  public replaceKeysforXSS(property: string): string {
    // Replace with character codes
    // property = property.replace(/"/g, '[REP34]');      //* character code 34
    property = property.replace(/%/g, "[REP37]"); //* character code 37
    property = property.replace(/&/g, "[REP38]"); //* character code 38
    // property = property.replace(/'/g, '[REP39]');      //* character code 39
    // property = property.replace(/\*/g, '[REP42]');     //* character code 42
    property = property.replace(/\+/g, "[REP43]"); //* character code 43
    property = property.replace(/,/g, "[REP44]"); //* character code 44
    property = property.replace(/-/g, "[REP45]"); //* character code 45
    property = property.replace(/\//g, "[REP47]"); //* character code 47
    property = property.replace(/:/g, "[REP58]"); //* character code 58
    property = property.replace(/;/g, "[REP59]"); //* character code 59
    property = property.replace(/</g, "[REP60]"); //* character code 60
    property = property.replace(/=/g, "[REP61]"); //* character code 61
    property = property.replace(/>/g, "[REP62]"); //* character code 62
    property = property.replace(/\|/g, "[REP124]"); //* character code 124
    return property;
  }
}
